import { Injectable } from '@angular/core';
import { HttpService } from '@app/@core/services/http.service';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QueuesService {
  // Observable for notifying components to refresh queue data
  private refreshQueuesSource = new Subject<void>();
  public refreshQueues$ = this.refreshQueuesSource.asObservable();

  constructor(private httpservice: HttpService) { }

  /**
   * Notify all subscribers to refresh their queue data
   * Called after application unlock or other operations that affect queue state
   */
  notifyRefreshQueues(): void {
    this.refreshQueuesSource.next();
  }

  getRegistrationTabQueues(payload: any = {}) {
    return this.httpservice.post(API_ENDPOINTS.REGISTRATION_TAB_QUEUE_DATA, payload);
  }
  updateLockStatus(data: any) {
    return this.httpservice.post(API_ENDPOINTS.TEMP_LOCK_QUEUE_APPLICATION, data);
  }
  getLicenseTypes() {
    return this.httpservice.get('/domain/lookup?requestType=LICENSE-TYPES');
  }
  getPersonIdByApplicationId(applicationId: number) {
    return this.httpservice.get(`/queues/person-id/${applicationId}`);
  }
  getInternalNotes(payload: { tabName: string; applicationId: number | string }) {
    return this.httpservice.post(API_ENDPOINTS.INTERNAL_NOTES_QUEUES, payload);
  }
}
